import { FetchError, StandardDispatchFunction } from './actionTypes';

export function fetchErrorOccurredAction(fetchError?: string | FetchError | undefined) {
  return (dispatch: StandardDispatchFunction): Promise<void> => {
    return dispatch({ type: 'FETCH_ERROR_OCCURRED', fetchError });
  };
}
